<template>
    <header class="main-header">
      <div class="grid-container">
        <div class="grid-x grid-padding-x align-justify">
          <div class="medium-3 cell">
            <router-link to="/">
              <img
                class="logo"
                src="@/assets/qtac-logo-red.png"
              >
            </router-link>
          </div>
          <NavigationBar v-if="showMenu" />
        </div>
      </div>
      <div id="alert-container" />
    </header>
  </template>
  
  <script>
  import NavigationBar from '@/components/layout/NavBar.vue';
  export default {
    name: 'MainHeader',
    components:{
      NavigationBar
    },
    props: {
      showMenu: Boolean
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>  
  
  </style>
  